import React from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  appendLocationFilter,
  removeLocationFilter,
} from "../../../../../../redux/actions/new-list";
import NumberFormat from "react-number-format";
import { InfoTableButton } from "../../../../../library/button";
import { Checkbox } from "../../../../../library/checkbox";
import { Label } from "../../../../../library/label";

const Index = ({ municipalities, item }) => {
  const dispatch = useDispatch();

  const filterLocations = useSelector(
    (state) => state.newList.listFilter.locations
  );

  const selectLocation = (selected, code) => {
    if (selected) {
      dispatch(appendLocationFilter(code));
    } else {
      dispatch(removeLocationFilter(code));
    }
  };

  return (
    <div className="single-location-container">
      <Row className="information-row">
        <Col className="title-col">
          <Checkbox
            checked={
              filterLocations &&
              filterLocations.includes(municipalities[item].code)
                ? true
                : false
            }
            onChange={(e) =>
              selectLocation(e.target.checked, municipalities[item].code)
            }
            municipalityId={municipalities[item].code}
            type="checkbox"
          />
          <Label version={1} weight="bold">
            {municipalities[item].title}
          </Label>
        </Col>
        <Col md={2} className="text-center">
          <InfoTableButton color="yellow" title={municipalities[item].code} />
        </Col>
        <Col md={2} className="text-right">
          <Label version={2} weight="regular">
            <NumberFormat
              value={municipalities[item].population}
              displayType={"text"}
              thousandSeparator={" "}
            />
          </Label>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
